import {
  REPORTS_SET_APPOINTMENTS,
  REPORTS_GET_FILTER_DATA,
  REPORTS_SET_FILTER_EMPLOYEE,
  REPORTS_SET_FILTER_END_DATE,
  REPORTS_SET_FILTER_START_DATE,
  REPORTS_SET_FILTER_STATUS,
  REPORTS_TOGGLE_CHANGE,
  REPORTS_ERROR_MESSAGE,
  REPORTS_HANDLE_REQUEST_CLOSE,
  REPORTS_SUCCESS_MESSAGE,
} from "../constants/ActionTypes";
import moment from "moment";

const initialState = {
  allData: [],
  currentData: [],
  filter: {
    startDate: null,
    endDate: null,
    status: undefined,
    employee: undefined,
  },
  toggle: false,
  errorMessage: false,
  successMessage: false,
  alertMessage: "",
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case REPORTS_SET_APPOINTMENTS:
      return { ...state, allData: payload, currentData: payload };

    case REPORTS_SET_FILTER_EMPLOYEE:
      return { ...state, filter: { ...state.filter, employee: payload } };
    case REPORTS_SET_FILTER_STATUS:
      return { ...state, filter: { ...state.filter, status: payload } };
    case REPORTS_SET_FILTER_START_DATE:
      return { ...state, filter: { ...state.filter, startDate: payload || null } };
    case REPORTS_SET_FILTER_END_DATE:
      return { ...state, filter: { ...state.filter, endDate: payload || null } };
    case REPORTS_GET_FILTER_DATA: {
      let { errorMessage, successMessage, alertMessage, allData, filter } = state;
      const { startDate, endDate, status, employee } = filter;
      let currentData = allData;
      if (startDate && endDate) {
        if (moment(startDate).isAfter(moment(endDate))) {
          errorMessage = true;
          alertMessage = "Start Date can't be after End Date.";
        } else {
          currentData = currentData.filter(
            item =>
              moment(item.from).isSameOrAfter(moment(startDate), "date") &&
              moment(item.from).isSameOrBefore(endDate, "date")
          );
        }
      }
      if (status && status !== "Select") {
        currentData = currentData.filter(item => item.status === status);
      }
      if (employee && employee !== "Select") {
        currentData = currentData.filter(item => {
          const myEmployee = item.employee
            ? `${item.employee.firstname} ${item.employee.lastname}`
            : "no employee";
          return employee === myEmployee;
        });
      }

      return { ...state, currentData, errorMessage, alertMessage };
    }

    case REPORTS_TOGGLE_CHANGE:
      return { ...state, toggle: payload };

    case REPORTS_ERROR_MESSAGE:
      return { ...state, errorMessage: true, alertMessage: payload };
    case REPORTS_SUCCESS_MESSAGE:
      return { ...state, successMessage: true, alertMessage: payload };
    case REPORTS_HANDLE_REQUEST_CLOSE:
      return { ...state, errorMessage: false, successMessage: false, alertMessage: "" };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/Reports.Reducer.js